import { render, staticRenderFns } from "./InfoPanelBlockedEnterprise.vue?vue&type=template&id=477fc11e"
import script from "./InfoPanelBlockedEnterprise.vue?vue&type=script&lang=ts"
export * from "./InfoPanelBlockedEnterprise.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports